import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="h-screen flex items-center justify-center bg-background">
        <span className="font-mono text-sm text-muted-foreground animate-blink">
          initializing forge...
        </span>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
